import { render, staticRenderFns } from "./InputSingleChoice.vue?vue&type=template&id=941853f8&scoped=true&lang=pug"
import script from "./InputSingleChoice.vue?vue&type=script&lang=ts"
export * from "./InputSingleChoice.vue?vue&type=script&lang=ts"
import style0 from "./InputSingleChoice.vue?vue&type=style&index=0&id=941853f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941853f8",
  null
  
)

export default component.exports